// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__79UTs","headerContent":"styles_headerContent__-qGoB"};